import ReactSelectAsync from 'react-select/async';
import ReactSelectAsyncCreatable from 'react-select/async-creatable';
import ReactSelect from 'react-select';
import ReactSelectCreatable from 'react-select/creatable';
/**
 * Selects and returns the appropriate react-select component variant (base, async, creatable, or async-creatable)
 * with proper typing to accept both standard react-select props and custom BaseSelect props.
 */
const useSelectComponent = (isAutocomplete, async) => {
  let SelectVariant;

  if (isAutocomplete) {
    SelectVariant = async ? ReactSelectAsyncCreatable : ReactSelectCreatable;
  } else {
    SelectVariant = async ? ReactSelectAsync : ReactSelect;
  }

  // Properly type the Select variant to accept both react-select and custom BaseSelect props
  return SelectVariant;
};

export default useSelectComponent;
